export const formatCurrency = (amount, fractionDigits = 0) => {
  amount = Math.floor(Number(amount || 0));
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};